import { forwardRef } from 'react';
import { styled } from 'styled-components';
import backImg from '../assets/optimized/red-envelope.webp';
import frontImg from '../assets/optimized/red-envelope-front.webp';

type EnvelopeProps = {
    onClick?: () => void;
    ariaLabel?: string;
    className?: string;
    style?: React.CSSProperties;
};

const Envelope = forwardRef<HTMLButtonElement, EnvelopeProps>(
    ({ onClick, ariaLabel, className, style }, ref) => {
        return (
            <Container 
                ref={ref}
                onClick={onClick} 
                aria-label={ariaLabel} 
                className={className} 
                style={style}
                type="button"
            >
                <Back src={backImg} alt="Envelope" />
                <Paper>
                  <PaperText> RSVP</PaperText>
                </Paper>
                <Front src={frontImg} alt="Envelope front" />
            </Container>
        );
    }
);

Envelope.displayName = 'Envelope';

export default Envelope;

const LayerImg = styled.img`
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const Back = styled(LayerImg)`
    z-index: 0;
    position: relative;
`;

const Front = styled(LayerImg)`
    z-index: 2;
    pointer-events: none;
`;

const Paper = styled.div`
    position: absolute;
    top: 35%;
    left: 2%;
    z-index: 1;
    width: 96%;
    height: 50%;
    background: white;
    transform: translateY(calc(-28% * var(--is-hovered, 0)));
    transition: transform 300ms ease;
`;

const PaperText = styled.div`
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.5rem;
    font-weight: 600;
    color: #511521;

    font-family: "SLTFTheSilverEditorial", cursive;
`;

const Container = styled.button`
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
    appearance: none;
    display: block;
    border-radius: 0;
    overflow: hidden;

    &:focus-visible {
        outline: 2px solid rgba(0, 0, 0, 0.4);
        outline-offset: 2px;
        pointer-events: none;
    }
`;

